import {DefaultAPIInstance} from "@/api";
import axios from "axios";

const finance_url = 'users/';
const payment_url = 'https://testoauth.homebank.kz/epay2/oauth2/token'

export const FinanceAPI = {
    getFinance(userId) {
        return DefaultAPIInstance.get(`${finance_url}${userId}/finance/`)
    },
    downloadFinance(userId, lang) {
        return DefaultAPIInstance.get(`${finance_url}${userId}/finance/download`, {responseType: 'blob', params: {language: lang}})
    },
    paymentService(payData) {
        return axios.post(payment_url, payData)
    },
    wooppayAuth(authData) {
        return axios.post('https://invoice-gw.test.wooppay.com/auth', authData)
    },
    wooppayPay({token, data}) {
        return axios.post('https://invoice-gw.test.wooppay.com/merchant/invoice', data, { headers: { 
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
    getWooppayCard({token, id}){
        return axios.post('https://invoice-gw.test.wooppay.com/merchant/linked-cards', id, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
    payWithCard({token, data}){
        return axios.post('https://invoice-gw.test.wooppay.com/merchant/invoice/frame', data, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
    deleteCard({token, invoiceID, id}){
        return axios.post(`https://invoice-gw.test.wooppay.com/invoice/${invoiceID}/unlink`, id, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
    wooppayAuthB(authData) {
        return axios.post('https://api-core.test.wooppay.com/v1/auth', authData)
    },
    wooppayPayBalance({tkn, payData}){
        return axios.post('https://api-core.test.wooppay.com/v1/invoice/create', payData, { headers: { 
            'accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': tkn
        }})
    },
    getReceipt({token, payData}){
        return axios.get(`https://invoice-gw.test.wooppay.com/merchant/receipt-pdf`, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }, responseType: 'blob', params: payData})
    },
    getReceiptBalance({token, payData}){
        return axios.get(`https://api-core.test.wooppay.com/v1/history/receipt/pdf/${payData.operation_id}`, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
    getOperationData({token, payData}){
        return axios.post(`https://invoice-gw.test.wooppay.com/merchant/operations`, payData, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
    getBalanceOperationData({token, payData}){
        return axios.post(`https://api-core.test.wooppay.com/v1/history/transaction/get-operations-data`, payData, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
    payBalance({token, balanceData}){
        return axios.post(`https://api-core.test.wooppay.com/v1/payment/approve-pay-from-mobile`, balanceData, { headers: { 
            'Content-Type': 'application/json',
            'Authorization': token
        }})
    },
}
